export default __webpack_public_path__ + "static/media/reload.426a3909.svg";